module.exports = __webpack_public_path__ + "img/vertical_6_2_3016.5dca54fc.png";